import React from 'react'
import "./EntryPage.css";
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function EntryPage() {
    const navigate = useNavigate();
    return (
        <>
            <section className='entry-section '>
                <Container>
                    <div className='entry-card'>
                        <div className='heading'>
                            <img
                                src={
                                    process.env.PUBLIC_URL + "/assets/Images/Logo/printout_logo.png"
                                }
                                className="logo_img"
                                alt="logo_img"
                            />
                        </div>
                        <div className='text-holder'>
                            <h1>CREATE AN ACCOUNT OR LOG IN</h1>
                            <p>TO ENJOY A SEAMLESS SHOPPING EXPERIENCE!</p>
                        </div>
                        {/* <div className='entry-btns'>
                            <button className='login-btn'>Login</button>
                        </div>
                        <div className='entry-btns'>
                            <button className='signup-btn'>Signup</button>
                        </div> */}
                        <div className="row">
                            <div className="col-6 mx-auto">
                                <button className='login-btn' onClick={() => navigate('/login')}>Login</button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6 mx-auto">
                                <button className='login-btn' onClick={() => navigate('/sign-up')}>Signup</button>
                            </div>
                        </div>
                    </div>
                </Container>

            </section>
        </>
    )
}
